if (!customElements.get('prosper-countdown')) {
  class ProsperCountdown extends HTMLElement {
    connectedCallback() {
      this.end = new Date(this.dataset.end).getTime();
      if (Number.isNaN(this.end)) return;
      this.values = {};
      this.querySelectorAll('[data-unit]').forEach((el) => {
        this.values[el.dataset.unit] = el;
      });
      this.tick();
      if (!this.expired) this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    tick() {
      const remaining = this.end - Date.now();
      if (remaining <= 0) {
        this.finish();
        return;
      }
      const seconds = Math.floor(remaining / 1000);
      this.set('days', Math.floor(seconds / 86400), false);
      this.set('hours', Math.floor((seconds % 86400) / 3600), true);
      this.set('minutes', Math.floor((seconds % 3600) / 60), true);
      this.set('seconds', seconds % 60, true);
    }

    set(unit, value, pad) {
      const el = this.values[unit];
      if (el) el.textContent = pad ? String(value).padStart(2, '0') : String(value);
    }

    finish() {
      this.expired = true;
      clearInterval(this.timer);
      if (this.dataset.expiredBehavior === 'hide') {
        const section = this.closest('.shopify-section');
        (section || this).hidden = true;
        return;
      }
      this.querySelectorAll('[data-countdown-upcoming]').forEach((el) => {
        el.hidden = true;
      });
      this.querySelectorAll('[data-countdown-expired]').forEach((el) => {
        el.hidden = false;
      });
    }
  }

  customElements.define('prosper-countdown', ProsperCountdown);
}
